export default class ThumborHelper {
    static Builder = class {

        constructor(imageUrl) {
            this.imageUrl = imageUrl;
        }


        baseUrl = "https://image.dmmkr.ir";
        compressSize = ""
        filters = []

        setImageCompressSize(width, height) {
            try {
                const _width = parseInt(width)
                const _height = parseInt(height)

                if (_width > 0 && _height > 0) {
                    this.compressSize = `/${width}x${height}`
                }

            } catch (e) {
                this.compressSize = ``
            }
            return this
        }

        convertWebp() {
            this.filters.push('format(webp)')

            return this
        }

        changeQuality(percent = 100) {
            this.filters.push(`quality(${percent})`)

            return this

        }

        addBlur(percent = 0) {
            this.filters.push(`blur(${percent})`)

            return this
        }

        maxBytes(byte = 0) {
            this.filters.push(`max_bytes(${byte})`)

            return this
        }
        addNoise(percent = 0) {
            this.filters.push(`noise(${percent})`)

            return this
        }

        build() {
            let finalUrl = this.baseUrl;
            finalUrl += "/unsafe";
            finalUrl += this.compressSize;

            let _filters = ""
            this.filters.map((item, index) => {
                _filters += `:${item}`
            })

            if (_filters.length > 0) {
                finalUrl += `/filters${_filters}`
            }

            finalUrl += `/${encodeURIComponent(this.imageUrl)}`

            return finalUrl
        }
    }
}
